import { GlobalExclusion } from '@/features/operations/components/pages/Programs/ProgramView/constant'

export interface GlobalExclusionTime {
  id: number
  oddEvenType: string
  weekDays: number[]
  active: boolean
  fromMonth: number
  fromDay: number
  toMonth: number
  toDay: number
  fromHour: number
  fromMinute: number
  toHour: number
  toMinute: number
  repeatCount: number
  repeatInterval: number
  isWholeYearPeriod: boolean
}

export const initialState: GlobalExclusionTimeState = {
  globalExclusionTimeData: {},
}

export interface GlobalExclusionTimeState {
  globalExclusionTimeData: Record<string, GlobalExclusion[]>
}